<template>
  <div class="vx-card p-6" v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '23') != null">
    <div class="flex flex-wrap" style="font-size: 40px; justify-content: center;">
      PERSONEL MENÜ YÖNETİMİ
    </div>
    <form class="vx-row" @submit.prevent="getDinamicMenuRouter()">
      <div style="width: 100%;">
        <div class="vx-row mt-5 flex justify-center">
          <div class="vx-col md:w-1/3 w-full">
            <label class="text-sm"><b>Personel</b></label>
            <v-select @input="getDinamicMenuRouter()" class="w-full" placeholder="Seçiniz" label="userName" :options="userList" v-model="routerSearch.userId" :reduce="(row) => row.userId">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <label class="text-sm"><b>Grup Adı</b></label>
            <v-select @input="getDinamicMenuRouter()" class="w-full" placeholder="Seçiniz" label="name" :options="routerGroupList" v-model="routerSearch.routerGroupId" :reduce="(row) => row.id">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
          <vs-button style="margin-top: 10px; margin-left: 10px;">Göster</vs-button>
          <vs-checkbox style="margin-top: 7px; margin-left: 20px;" v-model="selectAll" @input="SaveRouterUser(routerList[0], selectAll ? 'InsertAll' : 'DeleteAll', '')">Tümünü Ekle / Kaldır</vs-checkbox>
        </div>
        <div class="vx-row mt-5">
          <div class="vx-col mt-5 ml-5 mr-5 md:w-1/5 w-full" v-for="router in routerList" :key="router.routerId">
            <vs-checkbox v-model="router.isRouterUser" @input="SaveRouterUser(router, router.isRouterUser ? 'Insert' : 'Delete', '')">{{ router.routerName }}</vs-checkbox>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { repository } from "@/_services/repository.js";
import vSelect from "vue-select";

// Cell Renderer

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      userList: [],
      selectAll: false,
      userSearch: { userId: null },
      routerGroupList: [],
      routerGroupSearch: { id: null, name: null },
      routerList: [],
      routerSearch: { userId: null, routerGroupId: null },
    };
  },
  methods: {
    getUsers: async function () {
      this.userList = await repository.postEntity("HumanResource/getUser", { status: 1 }).then((r) => r.list);
    },
    getRouterGroup: async function () {
      this.routerGroupList = await repository.postEntity("ParametricScreens/getRouterGroup", this.routerGroupSearch).then((r) => r.list);
    },
    getDinamicMenuRouter: async function () {
      this.routerList = await repository.postEntity("ParametricScreens/getDinamicMenuRouter", this.routerSearch).then((r) => r.list);
      let amount = 0;
      for (let i = 0; i < this.routerList.length; i++) {
        if (this.routerList[i].isRouterUser) {
          amount += 1;
        }
      }
      if (this.routerList.length == amount) this.selectAll = true;
      else this.selectAll = false;
    },

    SaveRouterUser: async function (item, operation, messageText) {
      if (operation == "InsertAll" && this.selectAll) {
        messageText = "Tüm yetkiler verilecektir";
        //item.routerGroupId = this.routerSearch.routerGroupId;
      } else if (operation == "DeleteAll") {
        messageText = "Tüm yetkiler silinecektir";
      } else if (operation == "Delete") {
        messageText = "Personelin menü yetkisi silinecektir!";
      } else if (operation == "Insert") {
        messageText = "Personele menü yetkisi verilecektir!";
      }

      item.operation = operation;
      item.userId = this.routerSearch.userId;

      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: messageText,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) {
        this.$vs.loading();
        await repository.postEntity("ParametricScreens/SaveRouterUser", item);
        this.$vs.loading.close();

        await this.$swal.fire({
          icon: "success",
          title: "İşlem Başarılı",
          //text: "",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Tamam",
          cancelButtonText: "Hayır",
        });
        this.getDinamicMenuRouter();
      } else {
        this.getDinamicMenuRouter();
      }
    },
  },
  created: async function () {
    this.$vs.loading();
    await Promise.all([this.getUsers(), this.getRouterGroup()]);
    this.$vs.loading.close();
  },
};
</script>
